<template>
    <div>
        <Upload
            ref="upload"
            :action="action"
            :max-size="maxSize"
            :data="data"
            :name="name"
            :headers="headers"
            :format="format"
            :show-upload-list="showUploadList"
            :on-success="onSuccess"
            :on-error="onError"
            :on-remove="onRemove"
            :on-format-error="onFormatError"
            :on-exceeded-size="onExceededSize"
            :before-upload="onBeforeUpload"
            v-bind="$attrs"
            v-on="$listeners"
            style="display: inline-block"
        >
            <slot name="before"></slot>
            <Button
                icon="ios-cloud-upload-outline"
                :class="buttonClassName"
                v-bind="buttonProps"
                >上传文件</Button
            >
        </Upload>
        <slot name="tip"></slot>
    </div>
</template>
<script>
import { Upload } from 'view-design';
import API from '@/api';
export default {
    components: {
        Upload,
    },
    props: {
        // 文件大小,kb
        maxSize: {
            type: Number,
            default: 0,
        },
        // 额外参数
        data: {
            type: Object,
            default: () => {},
        },
        // 上传文件的参数名
        name: {
            type: String,
            default: 'file',
        },
        // 是否显示上传文件列表
        showUploadList: {
            type: Boolean,
            default: true,
        },
        // 支持的文件后缀名
        format: {
            type: Array,
            default: () => {
                return [
                    'JPG',
                    'JPGE',
                    'PNG',
                    'BMP',
                    'GIF',
                    'SVG',
                    'DWG',
                    'DOC',
                    'DOCX',
                    'XLS',
                    'XLSX',
                    'PPT',
                    'PPTX',
                    'PDF',
                    'RAR',
                    'ZIP',
                    '7ZIP',
                    '7Z',
                ];
            },
        },
        limit: {
            type: Number,
            default: 500,
        },
        buttonClassName: {
            type: [String, Array, Object],
            default: null,
        },
        buttonProps: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            action: API.server + 'entrance/attach/upload',
            headers: {
                Authorization: localStorage.getItem('token'),
            },
        };
    },
    methods: {
        /**
         * 文件上传成功时
         * @return res 服务器返回结果
         * @return file 当前文件
         * @return fileList 文件list
         */
        onSuccess(res, file, fileList) {
            if (res.success) {
                this.$Message.success('文件上传成功');
                this.$emit('on-success', { res, file, fileList });
            } else {
                this.$Message.error('文件上传失败');
            }
        },
        /**
         * 文件上传失败时
         * @return err 服务器返回的错误信息
         * @return file 当前文件
         * @return fileList 文件list
         */
        onError(err, file, fileList) {
            this.$Message.error('文件上传失败，请重试！');
            this.$emit('on-error', { err, file, fileList });
        },
        /**
         * 文件删除时
         * @return file 当前文件
         * @return fileList 文件list
         */
        onRemove(file, fileList) {
            this.$emit('on-remove', { file, fileList });
        },
        // 文件格式验证失败时
        onFormatError() {
            this.$Message.error('请选择符合要求的文件格式！');
        },
        // 文件超出大小限制时
        onExceededSize() {
            const mb = this.maxSize / 1024;

            this.$Message.error(
                `您选择的文件超过${mb}MB，无法进行上传！请进行压缩或精简后重试！`
            );
        },
        onBeforeUpload() {
            const { fileList } = this.$refs.upload;

            if (fileList.length + 1 > this.limit) {
                this.$Message.error('当前限制上传' + this.limit + '个文件');
                return false;
            }
        },
    },
};
</script>
